import { register } from 'swiper/element/bundle';
import { Component, OnInit } from '@angular/core';
import { AuthGuard } from './services/guards/auth.guard';
import { AppVmsService } from '@qid/common';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import * as allIcons from 'ionicons/icons';
import { addIcons } from 'ionicons';

register();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    IonApp,
    IonRouterOutlet
  ],
})
export class AppComponent implements OnInit {
  public loadingGuard: boolean = false;

  constructor(
    private authGuard: AuthGuard,
    private vmsService: AppVmsService,
  ) {
    this.initialize();
    addIcons(allIcons);
  }

  ngOnInit() {
    // Component initialization logic can go here
  }

  private async initialize() {
    if (!(await this.vmsService.checkEntry())) {
      this.loadingGuard = true;
      return;
    }

    this.authGuard.loading.subscribe((val) => {
      this.loadingGuard = val;
      if (!this.loadingGuard) {
      }
    });
  }
}
